import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SEO } from "../components/SEO";
import { MaskedLines, FadeUp, Overline } from "../components/Reveal";
import { SITE } from "../data/site";
import { SERVICES } from "../data/services";

const Services = () => (
  <div data-testid="services-page">
    <SEO
      title="Facials, Nano Needling & Dermaplaning Services in Orlando, FL | Lunar Ambitions"
      description="Explore customized facials, nano needling, dermaplaning, and nano infusion treatments at Lunar Ambitions, a licensed esthetician studio in Orlando, FL."
    />

    <section className="relative overflow-hidden bg-white pt-52 pb-16 lg:pt-72 sm:pb-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Overline>Lunar Ambitions · Orlando, FL</Overline>
        <h1
          className="mt-6 font-display font-normal tracking-tight leading-[1.06] text-navy text-4xl sm:text-5xl lg:text-6xl"
          data-testid="services-heading"
        >
          <MaskedLines lines={["Service Options"]} />
        </h1>
        <FadeUp delay={0.4}>
          <p className="mt-6 max-w-lg text-base sm:text-lg text-navy/70 leading-relaxed font-light">
            Personalized Facials, Nano Needling, and Dermaplaning in Orlando,
            FL
          </p>
        </FadeUp>
      </div>
    </section>

    <section className="bg-white pb-24 sm:pb-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
        {SERVICES.map((service, i) => (
          <FadeUp key={service.slug} delay={Math.min(i * 0.05, 0.35)}>
            <Link
              to={service.slug}
              data-testid={`services-card-${service.slug.slice(1)}`}
              className="group block"
            >
              <div className="relative overflow-hidden aspect-[4/5]">
                <img
                  src={service.image}
                  alt={service.imageAlt}
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-navy/10" />
                <span className="absolute top-4 left-4 font-display italic text-lg text-white drop-shadow-[0_1px_6px_rgba(2,27,60,0.6)]">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="mt-5 flex items-start justify-between gap-4">
                <div>
                  <h2 className="font-display text-xl sm:text-2xl text-navy leading-snug transition-colors duration-300 group-hover:text-gold">
                    {service.name}
                  </h2>
                  <p className="mt-2 text-xs tracking-[0.14em] uppercase text-navy/50">
                    {service.durationShort} · {service.price}
                  </p>
                </div>
                <ArrowUpRight
                  size={20}
                  className="mt-1 shrink-0 text-navy/30 transition-all duration-300 group-hover:text-gold group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </Link>
          </FadeUp>
        ))}
      </div>
    </section>

    <section className="bg-navy py-20 sm:py-28" data-testid="services-cta">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 text-center">
        <FadeUp>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Radiant Skin Starts Here
          </h2>
          <a
            href={SITE.bookingGeneral}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="services-book-now-button"
            className="group mt-9 inline-flex items-center gap-3 bg-gold text-navy text-sm tracking-[0.18em] uppercase font-semibold px-10 py-4 transition-colors duration-300 hover:bg-white"
          >
            Book Now
            <ArrowUpRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </a>
        </FadeUp>
      </div>
    </section>
  </div>
);

export default Services;
